import { Component, ElementRef, Inject, Optional, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { NMVTISMessageModel } from '../../models/nmvtis-message.model';
import { ValidationModel } from '../../../../shared/models/validation-results/validation.model';
import { AAMVAIntegrationService } from '../../../services/aamvaIntegration.service';
import { UntypedFormBuilder } from '@angular/forms';

export class NmvtisShellData {
    public nmvtisResponse: any;
    public nmvtisRequest: any;
    public businessTransactionId: number;
    public integrationInteractionMessageTypeId: number;
    public interactionManagerMessageId: number;
    public interactionManagerMessageContent: string;
    public nmvtisMessageModel: NMVTISMessageModel;
    constructor(public nmvtisMessage: any) { }
}

@Component({
    selector: 'nmvtis-shell',
    templateUrl: './nmvtis-shell-modal.html',
    inputs: ['nmvtisMessageModel'],
    queries: {
        'tabsContentRef': new ViewChild('tabsContentRef', { static: false })
    }
})

export class NmvtisShellModalComponent extends BaseComponent {
    public nmvtisMessageModel: NMVTISMessageModel;
    public validationModel: ValidationModel = new ValidationModel([]);
    public title: string;
    public dataLoaded = false;
    public tabsContentRef!: ElementRef; // Using "definite assignment" assertion (query).

    constructor(private fb: UntypedFormBuilder,
        public dialogRef: MatDialogRef<NmvtisShellModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: NmvtisShellData,
        private _aamvaIntegrationService: AAMVAIntegrationService
    ) {
        super();

        this.nmvtisMessageModel = this.data.nmvtisMessageModel;
        if (!this.nmvtisMessageModel) {
            this.nmvtisMessageModel = new NMVTISMessageModel();
            this.nmvtisMessageModel.businessTransactionId = this.data.businessTransactionId;
            this.nmvtisMessageModel.integrationInteractionMessageTypeId = this.data.integrationInteractionMessageTypeId;
            this.nmvtisMessageModel.interactionManagerMessageId = this.data.interactionManagerMessageId;
            this.nmvtisMessageModel.interactionManagerMessageContent = this.data.interactionManagerMessageContent;

            this.nmvtisMessageModel.nmvtisRequest = this.data.nmvtisRequest;
            this.nmvtisMessageModel.nmvtisResponse = this.data.nmvtisResponse;
        }

        switch (+this.nmvtisMessageModel.integrationInteractionMessageTypeId) {
            case 2:
                this.title = 'A vehicle has been found. Ownership Reason is MCO.';
                break;
            case 3:
                this.title = 'Vehicle found on NMVTIS.';
                break;
            case 4:
                this.title = 'Possible Stolen Vehicle Report must be prepared for this vehicle.';
                break;
            case 5:
                this.title = 'NMVTIS Brands Selection.';
                break;
            case 6:
                this.title = 'NMVTIS Error.';
                break;
            case 7:
                this.title = 'Warning - Validate that the VIN was entered correctly.';
                break;
            case 8:
                this.title = 'Vehicle Not Found.';
                break;
            case 9:
                this.title = 'Odometer Reading Low.';
                break;
        }

        // this.title += " for " + this.nmvtisMessageModel.businessTransactionId;
    }

    ngOnInit() {
        // update the nmvtis interaction status
        this.dataLoaded = true;
    }

    /**
     * Dismisses the modal.
     */
    onCancel() {
        this.dialogRef.close();
    }

    /**
     * Dismisses the modal and raises an event
     */
    onSaved() {
        // update the status to 7(done). don't await.
        this._aamvaIntegrationService.updateNmvtisInteractionMessageState(this.nmvtisMessageModel.businessTransactionId, this.nmvtisMessageModel.interactionManagerMessageId, 7)
            .subscribe(() => this.dialogRef.close(1));
    }

    onValidationErrors(event: any) {
        if (event && event.validationResults) {
            this.validationModel = new ValidationModel(event.validationResults);
            this.tabsContentRef.nativeElement.scrollTo(0, 0);
            this.tabsContentRef.nativeElement.scrollIntoView();
        }
    }

    /* createValidationMessage(message: string) {
        let tempErrors = [];
        let state: ValidationStateModel = new ValidationStateModel();
        state.validationType = "Error";
        tempErrors.push({ errorMessage: message, state: state });
        return new ValidationModel(tempErrors);
    }*/
}
